import React, { useState } from 'react';
import './App.css';
import SearchBar from './components/SearchBar';
import MovieGrid from './components/MovieGrid';

function App() {
  const [search, setSearch] = useState('');
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const API_KEY = 'fabfcacd';

  const searchMovies = async () => {
    if (!search) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`https://www.omdbapi.com/?s=${search}&apikey=${API_KEY}`);
      const data = await res.json();
      if (data.Response === 'True') {
        setMovies(data.Search);
      } else {
        setError('No movies found!');
        setMovies([]);
      }
    } catch {
      setError('Something went wrong!');
    }
    setLoading(false);
  };

  return (
    <div className="app">
      <h1>🎬 Movie Search</h1>
      <SearchBar search={search} setSearch={setSearch} searchMovies={searchMovies} />
      {loading && <p className="loading">Searching...</p>}
      {error && <p className="error">{error}</p>}
      <MovieGrid movies={movies} />
    </div>
  );
}

export default App;